"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routerURL = void 0;
const systemConfig_1 = require("@configs/systemConfig");
exports.routerURL = {
    property: {
        [systemConfig_1.SystemFunctionSettings.DF0001]: '/df0001'
    },
    nonPublic: {}
};
